import { UserId } from '@sona/shared-model-common';
import { AnalyticsInstance } from 'analytics';
import { Injectable } from '@angular/core';
import * as seline from '@seline-analytics/web';
import { cloneDeep } from 'lodash';

declare global {
    export interface Window {
        analytics: AnalyticsInstance;
    }
}

export type AnalyticsUser = {
    userId: UserId;
    email?: string;
    isAnonymous?: boolean;
    role?: string;
} & Record<string, unknown>;

@Injectable({ providedIn: 'root' })
export class SonaAnalytics {

    page() {
        seline.page();
        void window.analytics.page();
    }

    async track(name: string, payload?: object) {
        payload = payload ? cloneDeep(payload) : undefined;
        seline.track(name, payload as Record<string, unknown>);
        await window.analytics.track(name, payload);
    }

    setUser(user: AnalyticsUser) {
        const { userId, ...rest } = user;
        seline.setUser(user);
        void window.analytics.identify(userId, rest);
    }
}
